import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { BoxTdUI } from './ui';

export class BoxTd extends PureComponent {
    static displayName = 'BoxTdContainer';

    render() {
        const { ...rest } = this.props;

        // PUT OTHER PROPS AFTER {...rest}
        return <BoxTdUI {...rest} />;
    }
}

export const BoxTdContainer = compose()(BoxTd);
